import '../styles/MainMenu.css';

function MainMenu({ onSelectGame }) {
  return (
    <div className="menu-container">
      <h1 className="menu-title">Games</h1>
      <div className="menu-buttons">
        <button
          className="menu-button"
          onClick={() => onSelectGame('GST1')}
        >
          <span className="game-name">GSC</span>
        </button>
        <button
          className="menu-button"
          onClick={() => onSelectGame('GST2')}
        >
          <span className="game-name">DSC</span>
        </button>
      </div>
    </div>
  );
}

export default MainMenu;

